export const CompanyAddress = ({city, country}) => {
  return (
    <span className="address">
      {city}, {country}
    </span>
  );
};
